import AmioHttpService from '@/services/amio/amio-http.service'

class IndexGroupService extends AmioHttpService {
  async create(name) {
    const payload = { name }
    try {
      const response = await this.requestPost('/index-groups', payload)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async list() {
    try {
      const response = await this.requestGet('/index-groups')
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async get(id) {
    try {
      const response = await this.requestGet(`/index-groups/${id}`)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async update(id, patchData) {
    try {
      const response = await this.requestPatch(`/index-groups/${id}`, patchData)
      return response.data
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async delete(id) {
    try {
      await this.requestDelete(`/index-groups/${id}`)
    } catch (err) {
      throw this.handleError(err)
    }
  }

}

export default new IndexGroupService()
